/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const DEM_WORKFLOW_AREA = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {areaName: "Area 1",},
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -91.2579345703125,
                33.444047234512354
              ],
              [
                -90.5877685546875,
                33.444047234512354
              ],
              [
                -90.5877685546875,
                34.500898049218456
              ],
              [
                -91.2579345703125,
                34.500898049218456
              ],
              [
                -91.2579345703125,
                33.444047234512354
              ]
            ]
          ]
        }
      }
    ]
  };

export default DEM_WORKFLOW_AREA;